<template>
  <div>
    <v-row no-glutters class="body-rows">
      <v-col cols="12" md="7" class="left-cols1 pr-md-8">
        <p class="subtitle-2 font-weight-bold mb-2 mb-md-5 txt-666">
          <v-btn :disabled="cardloader" to="/pan" icon><v-icon>mdi-arrow-left</v-icon></v-btn> Step 2 of 6
        </p>
        <p class="headline font-weight-black mb-2">Data fetched from {{ verifytype }} record</p>
        <p class="subtitle-1 font-weight-regular txt-666">We need your {{ verifytype }} details for identity proof it is necessary.</p>
        <v-alert v-if="rejectdata.app_status == 'rejected' ? rejectdata.stage_wise_approval.digilocker == 'no' : ''" border="left" colored-border type="info" style="border: 1px solid #ebeef0 !important" class="mt-4 mx-auto rounded-xl text-left py-2" color="warning" elevation="0">
          <span class="subtitle-2 font-weight-regular"
            >Your Digilocker have been rejected due <b>{{ rejectdata.digilocker_reject_reason }}</b></span
          >
        </v-alert>

        <div v-if="Otp_screen" class="pt-6">
          <v-form v-if="rejectdata.stage_wise_approval && rejectdata.stage_wise_approval.digilocker == 'no'" @submit.prevent="validate()" v-model="valid" ref="form" lazy-validation>
            <p class="font-weight-medium fs-17 mb-0 mt-3">Your date of birth as per the PAN</p>
            <v-text-field v-model="dob" :readonly="cardloader" class="txt-field">
              <template #prepend-inner>
                <div class="mr-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.5289 0.666992C10.8049 0.666992 11.0289 0.890992 11.0289 1.16699L11.0292 1.7322C12.0026 1.79894 12.8111 2.13236 13.3833 2.70573C14.0079 3.33306 14.3366 4.23506 14.3333 5.31706V11.3991C14.3333 13.6204 12.9226 15.0004 10.6526 15.0004H5.01392C2.74392 15.0004 1.33325 13.6011 1.33325 11.3484V5.31573C1.33325 3.22052 2.59129 1.87562 4.64304 1.73243L4.64345 1.16699C4.64345 0.890992 4.86745 0.666992 5.14345 0.666992C5.41945 0.666992 5.64345 0.890992 5.64345 1.16699L5.64325 1.71966H10.0286L10.0289 1.16699C10.0289 0.890992 10.2529 0.666992 10.5289 0.666992ZM13.3333 6.60299H2.33325V11.3484C2.33325 13.0591 3.28525 14.0004 5.01392 14.0004H10.6526C12.3813 14.0004 13.3333 13.0764 13.3333 11.3991L13.3333 6.60299ZM10.8007 10.7979C11.0767 10.7979 11.3007 11.0219 11.3007 11.2979C11.3007 11.5739 11.0767 11.7979 10.8007 11.7979C10.5247 11.7979 10.2981 11.5739 10.2981 11.2979C10.2981 11.0219 10.5187 10.7979 10.7947 10.7979H10.8007ZM7.84239 10.7979C8.11839 10.7979 8.34239 11.0219 8.34239 11.2979C8.34239 11.5739 8.11839 11.7979 7.84239 11.7979C7.56639 11.7979 7.33972 11.5739 7.33972 11.2979C7.33972 11.0219 7.56039 10.7979 7.83639 10.7979H7.84239ZM4.87785 10.7979C5.15385 10.7979 5.37785 11.0219 5.37785 11.2979C5.37785 11.5739 5.15385 11.7979 4.87785 11.7979C4.60185 11.7979 4.37452 11.5739 4.37452 11.2979C4.37452 11.0219 4.59585 10.7979 4.87185 10.7979H4.87785ZM10.8007 8.20673C11.0767 8.20673 11.3007 8.43073 11.3007 8.70673C11.3007 8.98273 11.0767 9.20673 10.8007 9.20673C10.5247 9.20673 10.2981 8.98273 10.2981 8.70673C10.2981 8.43073 10.5187 8.20673 10.7947 8.20673H10.8007ZM7.84239 8.20673C8.11839 8.20673 8.34239 8.43073 8.34239 8.70673C8.34239 8.98273 8.11839 9.20673 7.84239 9.20673C7.56639 9.20673 7.33972 8.98273 7.33972 8.70673C7.33972 8.43073 7.56039 8.20673 7.83639 8.20673H7.84239ZM4.87785 8.20673C5.15385 8.20673 5.37785 8.43073 5.37785 8.70673C5.37785 8.98273 5.15385 9.20673 4.87785 9.20673C4.60185 9.20673 4.37452 8.98273 4.37452 8.70673C4.37452 8.43073 4.59585 8.20673 4.87185 8.20673H4.87785ZM10.0286 2.71966H5.64325L5.64345 3.36099C5.64345 3.63699 5.41945 3.86099 5.14345 3.86099C4.86745 3.86099 4.64345 3.63699 4.64345 3.36099L4.6431 2.73479C3.14961 2.86025 2.33325 3.76556 2.33325 5.31573V5.60299H13.3333L13.3333 5.31573C13.3359 4.49239 13.1146 3.85239 12.6753 3.41239C12.2896 3.0256 11.7258 2.79459 11.0295 2.73511L11.0289 3.36099C11.0289 3.63699 10.8049 3.86099 10.5289 3.86099C10.2529 3.86099 10.0289 3.63699 10.0289 3.36099L10.0286 2.71966Z"
                      fill="#121212"
                    />
                  </svg>
                </div>
              </template>
            </v-text-field>

            <p class="font-weight-medium fs-17 mb-0 mt-3">Your father name as per the PAN</p>
            <v-text-field
              v-model="fatherName"
              v-on:keypress="isLetter($event)"
              :readonly="cardloader"
              required
              type="text"
              :rules="[(v) => !!v || 'Father name is required', (v) => (v && v.trim().length >= 3) || 'Minimum 3 letters required', (v) => /^[A-Za-z\s]+$/.test(v) || 'Only letters are allowed']"
              oninput="this.value = this.value.toUpperCase().replace('  ', '')"
              class="txt-field"
            >
              <template #prepend-inner>
                <div class="mr-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M5 9C5.55228 9 6 8.55228 6 8C6 7.44772 5.55228 7 5 7C4.44772 7 4 7.44772 4 8C4 8.55228 4.44772 9 5 9Z" fill="#212121" />
                    <path d="M5 10C5.53043 10 6.03914 10.2107 6.41421 10.5858C6.78929 10.9609 7 11.4696 7 12H3C3 11.4696 3.21071 10.9609 3.58579 10.5858C3.96086 10.2107 4.46957 10 5 10Z" fill="#212121" />
                    <path d="M9.5 8.5H12.5" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M9.5 11.5H12.5" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                      d="M4.5 3.5H1.5C1.23478 3.5 0.98043 3.60536 0.792893 3.79289C0.605357 3.98043 0.5 4.23478 0.5 4.5V13.5C0.5 13.7652 0.605357 14.0196 0.792893 14.2071C0.98043 14.3946 1.23478 14.5 1.5 14.5H14.5C14.7652 14.5 15.0196 14.3946 15.2071 14.2071C15.3946 14.0196 15.5 13.7652 15.5 13.5V4.5C15.5 4.23478 15.3946 3.98043 15.2071 3.79289C15.0196 3.60536 14.7652 3.5 14.5 3.5H11.5"
                      stroke="#212121"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path d="M8 0.5C8.39782 0.5 8.77936 0.658035 9.06066 0.93934C9.34196 1.22064 9.5 1.60218 9.5 2V5.5H6.5V2C6.5 1.60218 6.65804 1.22064 6.93934 0.93934C7.22064 0.658035 7.60218 0.5 8 0.5Z" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
              </template>
            </v-text-field>

            <div class="d-none d-md-flex">
              <v-btn type="submit" :disabled="!valid" height="48px" color="#000" :loading="cardloader" class="white--text text-none rounded-pill elevation-0 mt-8"><span class="white--text subtitle-1 font-weight-medium px-6">Continue</span></v-btn>
            </div>
            <v-footer padless color="#fff" class="btn-footer btn-footer px-3 pt-3 pb-1 d-md-none">
              <v-btn type="submit" :disabled="!valid" height="48px" color="#000" :loading="cardloader" block class="white--text text-none rounded-pill elevation-0"><span class="white--text subtitle-1 font-weight-medium px-6">Continue</span></v-btn>
            </v-footer>
          </v-form>
          <v-form v-else @submit.prevent="validate()" v-model="valid" ref="form" lazy-validation>
            <p class="font-weight-medium fs-17 mb-0">Your Aadhaar Number <span class="red--text">*</span></p>
            <v-text-field readonly v-model="aadharNo" class="txt-field">
              <template #prepend-inner>
                <div class="mr-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="16" viewBox="0 0 25 16" fill="none">
                    <g clip-path="url(#clip0_472_4825)">
                      <path
                        d="M23.0085 6.27258C22.874 6.47562 22.8251 6.72001 22.784 6.97474C22.7338 7.28488 22.6807 7.58261 22.5708 7.87455C22.4387 8.22439 22.2168 8.61417 21.8307 8.91926C21.4325 7.84536 20.8525 6.84759 20.116 5.96939C20.5761 5.78596 21.0277 5.78877 21.399 5.84989C21.7074 5.90083 21.9924 6.00388 22.2869 6.11545C22.5284 6.2075 22.765 6.28747 23.0084 6.27258H23.0085ZM18.528 1.80295L18.5279 1.8032L18.5282 1.80312C18.5133 2.04593 18.5933 2.28197 18.6855 2.52297C18.7974 2.81673 18.9007 3.10098 18.9519 3.40864C19.0131 3.77932 19.0159 4.23038 18.8315 4.6898C17.9498 3.95614 16.9485 3.37887 15.871 2.98313C16.1775 2.59467 16.57 2.37195 16.9223 2.23963C17.2149 2.12996 17.5134 2.07711 17.8244 2.02683C18.0796 1.98597 18.3246 1.93734 18.528 1.80295ZM22.3024 10.6739C22.7894 10.7458 23.1769 10.9724 23.4665 11.2093C23.708 11.4073 23.903 11.6387 24.1022 11.8824C24.2651 12.0823 24.43 12.2696 24.6482 12.3782H22.4498C22.4492 11.8069 22.3998 11.2368 22.3024 10.6739ZM6.28752 1.80312L6.28769 1.80328V1.80295C6.49113 1.93726 6.7361 1.98589 6.99136 2.02691C7.30224 2.07703 7.60068 2.12996 7.89332 2.23954C8.24557 2.37187 8.63811 2.59467 8.94452 2.98305C7.86707 3.37876 6.86573 3.95606 5.9841 4.6898C5.79973 4.23038 5.80238 3.77932 5.86381 3.40856C5.91488 3.1009 6.01818 2.81665 6.13001 2.5228C6.2222 2.28189 6.30244 2.04593 6.28752 1.80312ZM1.80719 6.27275L1.80744 6.27283L1.80736 6.27267C2.05076 6.28747 2.28736 6.2075 2.52893 6.11553C2.8234 6.00388 3.10833 5.90083 3.41664 5.84989C3.78804 5.78885 4.2396 5.78604 4.69971 5.96948C3.96329 6.84773 3.38333 7.84548 2.98506 8.91935C2.5989 8.61417 2.37706 8.22447 2.24491 7.87455C2.13498 7.58261 2.08201 7.28488 2.03169 6.97474C1.99065 6.72001 1.94182 6.4757 1.80719 6.27275ZM0.16748 12.3783C0.38576 12.2697 0.550486 12.0824 0.713553 11.8825C0.912517 11.6389 1.10775 11.4075 1.34916 11.2096C1.63882 10.9725 2.02605 10.7459 2.5131 10.6741C2.41575 11.2369 2.36658 11.8071 2.36611 12.3783H0.16748ZM12.4079 0.166992V0.16724L12.4081 0.166992C12.5168 0.384833 12.7046 0.549165 12.9051 0.712009C13.1493 0.910497 13.3813 1.10518 13.5797 1.34601C13.8187 1.6368 14.0473 2.02617 14.1177 2.51644C13.553 2.4197 12.981 2.37109 12.408 2.37113C11.825 2.37113 11.2539 2.42124 10.6981 2.51644C10.7685 2.02625 10.9971 1.6368 11.2361 1.34618C11.4346 1.10518 11.6666 0.910497 11.9107 0.711843C12.1112 0.549248 12.299 0.384833 12.4079 0.166992Z"
                        fill="#121212"
                      />
                      <path d="M10.3656 12.3809L11.1212 12.3787C11.2204 11.7421 11.0263 11.2519 10.3809 11.3689C9.83687 11.4674 9.25257 12.0066 8.89941 12.3787L9.89556 12.3743C10.0066 12.3016 10.2238 12.2184 10.3131 12.2803C10.3464 12.3035 10.3639 12.3364 10.3656 12.3809Z" fill="#121212" />
                      <path
                        d="M13.7634 12.3781H14.706C14.7508 11.2676 14.5715 10.1209 14.054 9.12874C13.5833 8.22604 12.8053 7.61246 11.798 7.46417C10.3276 7.24773 8.84393 7.86876 7.58955 8.75716C6.22383 9.72446 5.09653 11.0382 4.11133 12.3782L5.35651 12.3763C6.4775 10.7913 9.05583 8.38483 10.9525 8.36911C11.5569 8.36415 12.1715 8.50566 12.6259 8.91008C12.9551 9.20318 13.3543 9.77226 13.3347 10.2342C13.3231 10.508 13.0795 10.592 12.8458 10.5071C12.6644 10.4413 12.5362 10.2758 12.4092 10.1018C11.9965 9.53647 11.3528 9.25983 10.6467 9.35626C9.80451 9.47114 8.76061 10.1235 8.08729 10.7167C7.50673 11.2285 6.97367 11.7884 6.47087 12.3782H7.80957C8.30026 11.7872 8.8184 11.2832 9.48443 10.8693C9.69516 10.7384 9.95473 10.5999 10.2276 10.5063C10.9158 10.2703 11.6007 10.3301 11.9048 11.1849C12.0243 11.521 12.0419 11.8159 12.007 12.3561V12.3782H12.9173L12.9196 12.3504C12.9203 12.0546 12.9138 11.8552 12.9406 11.562C12.9636 11.3092 13.0423 11.0474 13.2776 11.0163C13.7776 10.9118 13.7536 12.0215 13.7634 12.3782V12.3781Z"
                        fill="#121212"
                      />
                      <path
                        d="M15.697 12.3787H16.6475C16.6935 11.3484 16.605 10.1278 16.2708 9.06202C16.2064 8.85498 16.1306 8.65161 16.0439 8.45282C15.8416 7.99225 15.5694 7.57534 15.2449 7.19002C14.8841 6.76203 14.4543 6.37713 13.9698 6.07402C13.8261 5.98404 13.6778 5.90169 13.5254 5.82732V5.82715C13.3724 5.75245 13.2153 5.68649 13.0548 5.62957L13.0541 5.62932C11.2034 4.97373 9.33145 5.43993 7.76113 6.29203C7.45881 6.45652 7.16471 6.63562 6.87988 6.82869C6.60537 7.01459 6.33895 7.21213 6.08137 7.42077L6.08079 7.42118C5.71353 7.71872 5.3661 8.03982 5.04071 8.38244C4.96801 8.45927 4.89621 8.53751 4.82641 8.61649C4.63963 8.8278 4.3518 9.12396 4.43719 9.43013C4.50484 9.67295 4.81895 9.60133 4.9283 9.5178C5.09626 9.4279 5.28063 9.2854 5.43856 9.15216C5.65219 8.97171 5.85406 8.77735 6.06571 8.59441C6.9215 7.85422 7.8136 7.28348 8.69228 6.89717C8.88073 6.81421 9.07232 6.73854 9.26662 6.67031C9.45333 6.60472 9.6427 6.54694 9.83424 6.49713L9.83507 6.49688C11.4701 6.07344 13.2468 6.34777 14.3844 7.67789C15.4803 8.95922 15.6803 10.6743 15.697 12.3788V12.3787ZM3.90455 10.9304C4.00668 10.8353 4.11072 10.7112 4.21916 10.5739C4.37087 10.3819 4.38612 10.196 4.3261 10.0618C4.30443 10.0129 4.27181 9.9696 4.23076 9.9352C4.19106 9.90198 4.14405 9.87857 4.09356 9.86689C3.96995 9.83869 3.82206 9.88285 3.69646 10.0353C3.55454 10.2075 3.35847 10.5022 3.31843 10.7629C3.31075 10.8094 3.30925 10.8568 3.31396 10.9037C3.31893 10.9471 3.33054 10.9883 3.35002 11.0259L3.35018 11.0262C3.38218 11.0874 3.43615 11.1197 3.50803 11.1224C3.52303 11.1229 3.53928 11.1222 3.55652 11.1203C3.57335 11.1185 3.59159 11.1151 3.61099 11.1107V11.1108L3.61199 11.1106C3.70881 11.0874 3.80564 11.0224 3.90455 10.9303V10.9304Z"
                        fill="#121212"
                      />
                      <path
                        d="M18.0745 12.3785L18.0812 12.3784H18.0846C18.1841 12.3838 18.3567 12.3382 18.4563 12.1706C18.4761 12.1371 18.4931 12.0988 18.506 12.0554C18.5193 12.0112 18.5284 11.961 18.5322 11.9046L18.5329 11.8931C18.6085 9.25978 17.8 7.07971 16.4274 5.59874C16.1632 5.31333 15.8747 5.05139 15.5651 4.81587C15.2587 4.58298 14.9322 4.37768 14.5895 4.20237H14.5894L14.5839 4.19972L14.5838 4.19956C13.4301 3.61137 12.1216 3.38551 10.8374 3.4941C10.3366 3.5363 9.84144 3.62907 9.35946 3.77099L9.35607 3.77206C8.03528 4.16185 6.80618 4.93554 5.80456 5.95064C5.51231 6.24673 5.24049 6.56222 4.99097 6.89495C5.69339 6.29039 6.44697 5.76009 7.23519 5.33872C7.41092 5.24464 7.58937 5.15572 7.77032 5.07208C7.94933 4.98934 8.13089 4.91222 8.31474 4.84084L8.31524 4.84068L8.31573 4.84043C9.01211 4.5704 9.69861 4.39821 10.3853 4.3213C11.0719 4.24438 11.759 4.26258 12.4567 4.37324C12.9533 4.45214 13.438 4.58182 13.8746 4.76327C13.9593 4.79842 14.0427 4.8358 14.1242 4.87533C14.2048 4.91428 14.2841 4.95564 14.3618 4.99939H14.3619L14.3632 5.00005L14.3631 5.00013C15.9003 5.8399 16.9683 7.56295 17.4386 9.50847C17.6233 10.2734 17.7141 11.0578 17.7091 11.8446V11.8448L17.7088 11.8674C17.7167 12.0781 17.7891 12.2544 17.9131 12.3337C17.9361 12.3484 17.9612 12.36 17.9878 12.3674H17.9879C18.0151 12.3751 18.044 12.379 18.0745 12.3785Z"
                        fill="#121212"
                      />
                      <path d="M15.3259 3.60254C19.0219 4.82035 21.6929 8.2877 21.7085 12.3787H19.8797C20.0007 8.80509 18.4373 5.5794 15.3259 3.60254Z" fill="#121212" />
                      <path
                        d="M4.59498 15.2476H3.85524L3.67203 15.8906H3.08252L3.86262 13.4282H4.60957L5.41164 15.8906H4.79643L4.59498 15.2476ZM3.93947 14.8311H4.5071C4.35821 14.35 4.26171 14.02 4.21777 13.8409H4.2104L4.09326 14.3086L3.93947 14.8311ZM7.31216 15.2476H6.57234L6.3893 15.8906H5.7997L6.57964 13.4282H7.32683L8.12882 15.8906H7.51361L7.31216 15.2476ZM6.65657 14.8311H7.2242C7.07531 14.35 6.97881 14.02 6.93487 13.8409H6.92758L6.81044 14.3086L6.65657 14.8311ZM8.69255 15.8797V13.4611C8.9367 13.4245 9.19792 13.4062 9.47622 13.4062C10.0024 13.4062 10.3802 13.5158 10.6092 13.7357C10.838 13.9555 10.9521 14.2429 10.9521 14.5973C10.9521 15.0162 10.8221 15.3408 10.5615 15.5709C10.3008 15.801 9.89868 15.9161 9.35543 15.9161C9.10399 15.9161 8.88298 15.904 8.69255 15.8797ZM9.26018 13.8629V15.4668C9.29193 15.4741 9.36032 15.4777 9.46528 15.4777C9.74722 15.4777 9.96575 15.4035 10.1202 15.2555C10.2746 15.1075 10.3515 14.8957 10.3515 14.6192C10.3515 14.3659 10.2814 14.1728 10.1403 14.0401C9.99933 13.9074 9.79614 13.8409 9.53118 13.8409C9.42009 13.8409 9.32973 13.8484 9.26018 13.8629ZM11.5599 13.4282H12.1275V14.3744H13.0979V13.4282H13.6656V15.8906H13.0979V14.864H12.1275V15.8906H11.5599V13.4282ZM15.7235 15.2476H14.9838L14.8007 15.8906H14.2111L14.9912 13.4282H15.7382L16.5403 15.8906H15.925L15.7235 15.2476ZM15.068 14.8311H15.6356C15.4867 14.35 15.3903 14.02 15.3463 13.8409H15.339L15.2218 14.3086L15.068 14.8311ZM18.4407 15.2476H17.7009L17.5178 15.8906H16.9282L17.7082 13.4282H18.4553L19.2573 15.8906H18.6421L18.4407 15.2476ZM17.7851 14.8311H18.3527C18.2038 14.35 18.1073 14.02 18.0634 13.8409H18.0561L17.9389 14.3086L17.7851 14.8311ZM19.821 15.8905V13.4611C20.0287 13.4245 20.2838 13.4062 20.5865 13.4062C20.9601 13.4062 21.2286 13.4678 21.3922 13.5908C21.5557 13.7137 21.6375 13.8897 21.6375 14.1187C21.6375 14.2551 21.5966 14.3781 21.5142 14.4883C21.4341 14.5969 21.3224 14.6783 21.1944 14.7215V14.736C21.3482 14.7934 21.4593 14.9444 21.5277 15.1891C21.6534 15.6299 21.7217 15.8638 21.7327 15.8906H21.1541C21.1053 15.7993 21.0467 15.6081 20.9783 15.317C20.9442 15.1709 20.8977 15.0686 20.8392 15.0101C20.7806 14.9516 20.6866 14.9225 20.5572 14.9225H20.3814V15.8906H19.821V15.8905ZM20.3814 13.8409V14.5169H20.6158C20.7574 14.5169 20.869 14.4846 20.9509 14.4207C21.0327 14.3568 21.0736 14.2709 21.0736 14.1625C21.0736 14.0541 21.0369 13.97 20.9631 13.9111C20.8893 13.8519 20.7842 13.8227 20.6488 13.8227C20.5157 13.8227 20.4266 13.8289 20.3814 13.8409Z"
                        fill="#121212"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_472_4825">
                        <rect width="24.8705" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </template>

              <template #append>
                <p class="mb-0">
                  <v-icon size="16" color="#37A668">mdi-checkbox-marked-circle-outline</v-icon>
                  <span style="text-decoration: none; color: #37a668; font-size: 12px"><b> Verified</b></span>
                </p>
              </template>
            </v-text-field>

            <p class="font-weight-medium fs-17 mb-0 mt-3">Your Name (as on Aadhaar) <span class="red--text">*</span></p>
            <v-text-field v-model="name" readonly class="txt-field">
              <template #prepend-inner>
                <div class="mr-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M5 9C5.55228 9 6 8.55228 6 8C6 7.44772 5.55228 7 5 7C4.44772 7 4 7.44772 4 8C4 8.55228 4.44772 9 5 9Z" fill="#212121" />
                    <path d="M5 10C5.53043 10 6.03914 10.2107 6.41421 10.5858C6.78929 10.9609 7 11.4696 7 12H3C3 11.4696 3.21071 10.9609 3.58579 10.5858C3.96086 10.2107 4.46957 10 5 10Z" fill="#212121" />
                    <path d="M9.5 8.5H12.5" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M9.5 11.5H12.5" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                      d="M4.5 3.5H1.5C1.23478 3.5 0.98043 3.60536 0.792893 3.79289C0.605357 3.98043 0.5 4.23478 0.5 4.5V13.5C0.5 13.7652 0.605357 14.0196 0.792893 14.2071C0.98043 14.3946 1.23478 14.5 1.5 14.5H14.5C14.7652 14.5 15.0196 14.3946 15.2071 14.2071C15.3946 14.0196 15.5 13.7652 15.5 13.5V4.5C15.5 4.23478 15.3946 3.98043 15.2071 3.79289C15.0196 3.60536 14.7652 3.5 14.5 3.5H11.5"
                      stroke="#212121"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path d="M8 0.5C8.39782 0.5 8.77936 0.658035 9.06066 0.93934C9.34196 1.22064 9.5 1.60218 9.5 2V5.5H6.5V2C6.5 1.60218 6.65804 1.22064 6.93934 0.93934C7.22064 0.658035 7.60218 0.5 8 0.5Z" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
              </template>

              <template #append>
                <p class="mb-0">
                  <v-icon size="16" color="#455A64">mdi-gender-male</v-icon>
                  <span style="text-decoration: none; color: #455a64; font-size: 12px"
                    ><b> {{ gender }}</b></span
                  >
                </p>
              </template>
            </v-text-field>

            <p class="font-weight-medium fs-17 mb-0 mt-3">Your Date of Birth (match PAN for seamless verification) <span class="red--text">*</span></p>
            <v-text-field v-model="dob" readonly class="txt-field mb-1" hide-details>
              <template #prepend-inner>
                <div class="mr-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.5289 0.666992C10.8049 0.666992 11.0289 0.890992 11.0289 1.16699L11.0292 1.7322C12.0026 1.79894 12.8111 2.13236 13.3833 2.70573C14.0079 3.33306 14.3366 4.23506 14.3333 5.31706V11.3991C14.3333 13.6204 12.9226 15.0004 10.6526 15.0004H5.01392C2.74392 15.0004 1.33325 13.6011 1.33325 11.3484V5.31573C1.33325 3.22052 2.59129 1.87562 4.64304 1.73243L4.64345 1.16699C4.64345 0.890992 4.86745 0.666992 5.14345 0.666992C5.41945 0.666992 5.64345 0.890992 5.64345 1.16699L5.64325 1.71966H10.0286L10.0289 1.16699C10.0289 0.890992 10.2529 0.666992 10.5289 0.666992ZM13.3333 6.60299H2.33325V11.3484C2.33325 13.0591 3.28525 14.0004 5.01392 14.0004H10.6526C12.3813 14.0004 13.3333 13.0764 13.3333 11.3991L13.3333 6.60299ZM10.8007 10.7979C11.0767 10.7979 11.3007 11.0219 11.3007 11.2979C11.3007 11.5739 11.0767 11.7979 10.8007 11.7979C10.5247 11.7979 10.2981 11.5739 10.2981 11.2979C10.2981 11.0219 10.5187 10.7979 10.7947 10.7979H10.8007ZM7.84239 10.7979C8.11839 10.7979 8.34239 11.0219 8.34239 11.2979C8.34239 11.5739 8.11839 11.7979 7.84239 11.7979C7.56639 11.7979 7.33972 11.5739 7.33972 11.2979C7.33972 11.0219 7.56039 10.7979 7.83639 10.7979H7.84239ZM4.87785 10.7979C5.15385 10.7979 5.37785 11.0219 5.37785 11.2979C5.37785 11.5739 5.15385 11.7979 4.87785 11.7979C4.60185 11.7979 4.37452 11.5739 4.37452 11.2979C4.37452 11.0219 4.59585 10.7979 4.87185 10.7979H4.87785ZM10.8007 8.20673C11.0767 8.20673 11.3007 8.43073 11.3007 8.70673C11.3007 8.98273 11.0767 9.20673 10.8007 9.20673C10.5247 9.20673 10.2981 8.98273 10.2981 8.70673C10.2981 8.43073 10.5187 8.20673 10.7947 8.20673H10.8007ZM7.84239 8.20673C8.11839 8.20673 8.34239 8.43073 8.34239 8.70673C8.34239 8.98273 8.11839 9.20673 7.84239 9.20673C7.56639 9.20673 7.33972 8.98273 7.33972 8.70673C7.33972 8.43073 7.56039 8.20673 7.83639 8.20673H7.84239ZM4.87785 8.20673C5.15385 8.20673 5.37785 8.43073 5.37785 8.70673C5.37785 8.98273 5.15385 9.20673 4.87785 9.20673C4.60185 9.20673 4.37452 8.98273 4.37452 8.70673C4.37452 8.43073 4.59585 8.20673 4.87185 8.20673H4.87785ZM10.0286 2.71966H5.64325L5.64345 3.36099C5.64345 3.63699 5.41945 3.86099 5.14345 3.86099C4.86745 3.86099 4.64345 3.63699 4.64345 3.36099L4.6431 2.73479C3.14961 2.86025 2.33325 3.76556 2.33325 5.31573V5.60299H13.3333L13.3333 5.31573C13.3359 4.49239 13.1146 3.85239 12.6753 3.41239C12.2896 3.0256 11.7258 2.79459 11.0295 2.73511L11.0289 3.36099C11.0289 3.63699 10.8049 3.86099 10.5289 3.86099C10.2529 3.86099 10.0289 3.63699 10.0289 3.36099L10.0286 2.71966Z"
                      fill="#121212"
                    />
                  </svg>
                </div>
              </template>
            </v-text-field>
            <p v-if="ocrDOB.stat" class="caption font-weight-medium warning--text">your aadhar and pan DOB mismatch, so we will print DOB as per the PAN.</p>

            <p class="font-weight-medium fs-17 mb-0" :class="ocrDOB.stat ? 'mt-3' : 'mt-7'">Your Father's Name (for KYC records) <span class="red--text">*</span></p>
            <v-text-field v-model="fatherName" v-on:keypress="isLetter($event)" :readonly="father" required type="text" :rules="[(v) => !!v || 'Father name is required', (v) => (v && v.trim().length >= 3) || 'Minimum 3 letters required']" oninput="this.value = this.value.toUpperCase().replace('  ', '')" class="txt-field">
              <template #prepend-inner>
                <div class="mr-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M5 9C5.55228 9 6 8.55228 6 8C6 7.44772 5.55228 7 5 7C4.44772 7 4 7.44772 4 8C4 8.55228 4.44772 9 5 9Z" fill="#212121" />
                    <path d="M5 10C5.53043 10 6.03914 10.2107 6.41421 10.5858C6.78929 10.9609 7 11.4696 7 12H3C3 11.4696 3.21071 10.9609 3.58579 10.5858C3.96086 10.2107 4.46957 10 5 10Z" fill="#212121" />
                    <path d="M9.5 8.5H12.5" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M9.5 11.5H12.5" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                      d="M4.5 3.5H1.5C1.23478 3.5 0.98043 3.60536 0.792893 3.79289C0.605357 3.98043 0.5 4.23478 0.5 4.5V13.5C0.5 13.7652 0.605357 14.0196 0.792893 14.2071C0.98043 14.3946 1.23478 14.5 1.5 14.5H14.5C14.7652 14.5 15.0196 14.3946 15.2071 14.2071C15.3946 14.0196 15.5 13.7652 15.5 13.5V4.5C15.5 4.23478 15.3946 3.98043 15.2071 3.79289C15.0196 3.60536 14.7652 3.5 14.5 3.5H11.5"
                      stroke="#212121"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path d="M8 0.5C8.39782 0.5 8.77936 0.658035 9.06066 0.93934C9.34196 1.22064 9.5 1.60218 9.5 2V5.5H6.5V2C6.5 1.60218 6.65804 1.22064 6.93934 0.93934C7.22064 0.658035 7.60218 0.5 8 0.5Z" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
              </template>
            </v-text-field>

            <v-textarea auto-grow readonly rows="1" row-height="4" hide-details v-model="address" label="Your address" flat solo background-color="#F6F7F7" class="txt-field elevation-0 rounded-lg mt-4" persistent-hint> </v-textarea>
            <p class="caption font-weight-medium txt-666 mb-16 pb-3 mb-md-0 mt-1">This is your communication address—it’ll help us stay in touch!</p>
            <div class="d-none d-md-flex">
              <v-btn v-if="digistageis" @click="KycFetchDisp ? setKradataUpdate() : connectDigio()" style="border: 2px solid #444 !important" outlined height="48px" color="#000" class="text-none rounded-pill elevation-0 mr-4 mt-8"
                ><span class="subtitle-1 font-weight-medium px-6">{{ KycFetchDisp ? "Switch with digilocker" : "Change" }}</span></v-btn
              >
              <v-btn type="submit" :disabled="!valid || (fatherName && fatherName.trim()) ? false : true" height="48px" color="#000" :loading="cardloader" class="white--text text-none rounded-pill elevation-0 mt-8"><span class="white--text subtitle-1 font-weight-medium px-6">Continue</span></v-btn>
            </div>
            <v-footer padless color="#fff" class="btn-footer btn-footer px-3 pt-3 pb-1 d-md-none">
              <v-row>
                <v-col cols="6">
                  <v-btn v-if="digistageis" @click="KycFetchDisp ? setKradataUpdate() : connectDigio()" style="border: 2px solid #444 !important" outlined height="48px" color="#000" block class="text-none rounded-pill elevation-0"
                    ><span class="subtitle-1 font-weight-medium">{{ KycFetchDisp ? "Switch with digilocker" : "Change" }}</span></v-btn
                  >
                </v-col>
                <v-col cols="6">
                  <v-btn type="submit" :disabled="!valid || (fatherName && fatherName.trim()) ? false : true" height="48px" color="#000" :loading="cardloader" block class="white--text text-none rounded-pill elevation-0"
                    ><span class="white--text subtitle-1 font-weight-medium px-6">Continue</span></v-btn
                  >
                </v-col>
              </v-row>
            </v-footer>
          </v-form>
        </div>

        <div v-if="kycLoader">
          <v-card width="100%" class="text-center py-16 elevation-0 mt-10">
            <v-progress-circular class="mx-auto" :size="60" :width="4" color="#0037B7" indeterminate></v-progress-circular>
            <p class="font-weight-bold mt-2">Don't press back or close while fetching your data...</p>
          </v-card>
        </div>

        <div v-if="!Otp_screen && !kycLoader">
          <v-card width="100%" class="text-center py-16 elevation-0 mt-10">
            <v-progress-circular class="mx-auto" :size="60" :width="4" color="#0037B7" indeterminate></v-progress-circular>
          </v-card>
        </div>
      </v-col>
      <v-col cols="5" class="rgt-cols d-none d-md-block pt-0">
        <v-container fill-height class="d-block text-center">
          <img src="@/assets/onb3.svg" class="rgt-img" alt="rgt-img" />
        </v-container>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import api from "@/api";
export default {
  data: () => ({
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
    valid: true,
    menu: false,
    modal: false,
    menu2: false,
    Otp_screen: false,
    name: null,
    dob: null,
    gender: null,
    aadharNo: null,
    address: null,
    country: null,
    district: null,
    fatherName: null,
    father: true,
    panName: "",
    pinCode: null,
    state: null,
    genders: null,
    cardloader: false,
    kycLoader: false, 
    fetchdataerror: false,
    dialog: true,
    rejectdata: [],

    panInput: null,

    ocrDOB: [],
    digistageis: false,

    verifytype: "Aadhaar",
    KycFetchDisp: false,
    codegeneraterdata:[],

  }),
  created() {
    let config = {
      method: "post",
      url: api.api_url + "/getstart?mob=" + atob(localStorage.getItem("hash")),
      headers: {
        "Content-Type": "application/json",
        "mobile":atob(localStorage.getItem("hash"))
      },
    };

    let axiosThis = this;
    axios
      .request(config)
      .then((response) => {
        if (response.data && response.data.panname) axiosThis.panName = response.data.panname.toString().trim();
        let p = response.data.data_type;
        if (p && p.check && p.check.pan == "yes") {
          axiosThis.$emit("snack", 0, "Your PAN data has been cleared. Please re-verify your PAN to continue.");
          axiosThis.$router.push("/pan");
          return;
        }
        if (
          response.data.data_type && response.data.kra_esigned != 'Yes'  &&
          response.data.stage_wise_approval.digilocker != "yes" &&
          (p.stage == "verification" ||
            p.stage == "digilocker" ||
            p.stage == "panproof" ||
            p.stage == "personal" ||
            p.stage == "bank" ||
            p.stage == "bankproof" ||
            p.stage == "segment" ||
            p.stage == "declartaion" ||
            p.stage == "signature" ||
            p.stage == "nominee" ||
            p.stage == "selfie" ||
            p.stage == "submit")
        ) {
          axiosThis.verifytype = response.data.data_type && response.data.data_type.kra == "true" ? "KRA" : "Aadhaar";
          axiosThis.$emit("clicked", 2, response.data);
          axiosThis.digistageis = response.data.stage_wise_approval && response.data.stage_wise_approval.digilocker == "yes" ? false : true;
          response.data.app_status == "rejected" && response.data.stage_wise_approval.digilocker == "no" ? (axiosThis.rejectdata = response.data) : (axiosThis.rejectdata = []);
        } else {
          axiosThis.$router.push(p ? {name: p.stage} : "/");
        }
      })
      .catch((error) => {
        console.log(error);
        axiosThis.$emit("snack", 0, error);
      });
  },
  methods: {
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[A-Za-z]+$/.test(char) || char == " ") return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    toNext() {
      this.cardloader = true;
      this.$emit("changed", 0);
      if (this.rejectdata.app_status == "rejected" && this.rejectdata.stage_wise_approval.digilocker == "no") {
        this.$emit("steged", "digilocker");
      } else {
        var configq = {
          method: "post",
          url: api.api_url + "/check_file?mob=" + atob(localStorage.getItem("hash")),
          headers: {"mobile":atob(localStorage.getItem("hash"))},
        };
        let axiosThis = this;
        axios(configq)
          .then(function (response) {
            if (response.data != "no file data found") {
              if ("pan_Status" in response.data && response.data["pan_Status"]) {
                var panresponse = JSON.parse(response.data["pan_Status"]);
                if ("pan" in panresponse && panresponse["pan"] == true) {
                  axiosThis.$emit("clicked", "personal");
                } else {
                  axiosThis.$emit("clicked", "panproof");
                }
              } else {
                axiosThis.$emit("clicked", "personal");
              }
            } else {
              axiosThis.$emit("snack", 0, response.data);
            }
            axiosThis.cardloader = false;
          })
          .catch(function (error) {
            axiosThis.cardloader = false;
            console.log(error);
            axiosThis.$emit("snack", 0, error);
          });
      }
    },

       connectDigio(){
      this.cardloader = true;
      this.codegeneraterdata = []
        const axios = require('axios');

        let config = {
          method: 'get',
          maxBodyLength: Infinity,
          url:  api.api_url + `/digilocker_code_generator?mobile=${atob(localStorage.getItem("hash"))}`,
          headers: { }
        };
var axiosThis = this;
        axios.request(config)
        .then((response) => {
          console.log(JSON.stringify(response.data));
          if(response.data.status == 'success'){
            axiosThis.codegeneraterdata = response.data
            axiosThis.connectDigionew()
          }else{
  axiosThis.$emit("snack", 0, response.data);
            axiosThis.cardloader = false;
          }
            

        })
        .catch((error) => {
          console.log(error);
          axiosThis.cardloader = false;
            axiosThis.$emit("snack", 0, error);
        });

    },


    connectDigionew() {
      this.$emit("changed", 2);
      this.kycLoader = true;
      this.Otp_screen = false;
      var stateid = "signup" + Math.random().toString(36).substring(7);
      sessionStorage.setItem("state", stateid);
      var config = {
        method: "post",
        url: api.api_url + "/digiLocker-transactionid?mob=" + atob(localStorage.getItem("hash")) + "&id=" + stateid,
        headers: {"mobile":atob(localStorage.getItem("hash"))},
      };
      var axiosThis = this;
      axios(config)
        .then(function () {
          // C86AC39E
          // 692DFD73
          // DED7DF29
          localStorage.removeItem("digiattemt");
window.location.href =
  "https://digilocker.meripehchaan.gov.in/public/oauth2/1/authorize" +
  "?response_type=code" +
  "&client_id=YWD31564CE" +
  "&state=" + stateid +
  "&redirect_uri=https%3A%2F%2Foa.zebuetrade.com%2Fdigilocker" +
  "&code_challenge=" + (axiosThis.codegeneraterdata.code_challenge ? axiosThis.codegeneraterdata.code_challenge : '') +
  "&code_challenge_method=S256" +
  "&scope=openid";        })
        .catch(function (error) {
          console.log(error);
          axiosThis.$emit("snack", 0, error);
          axiosThis.cardloader = false;
          alert("Server is not reachable, please try again later. \n  For support Contact us : 93 8010 8010  or  \n Mail us : assist@zebuetrade.com");
          axiosThis.cardloader = false;
        });
    },

    

    validate() {
      if (this.$refs.form.validate() == true) {
        var stripWs = (v) => (v || "").toString().replace(/\s+/g, "").toUpperCase();
        if (stripWs(this.name) && stripWs(this.fatherName) && stripWs(this.name) === stripWs(this.fatherName)) {
          this.$emit("snack", 0, "Your name and father's name cannot be the same");
          return;
        }
        if (stripWs(this.panName) && stripWs(this.fatherName) && stripWs(this.panName) === stripWs(this.fatherName)) {
          this.$emit("snack", 0, "PAN Name and Father Name cannot be the same");
          return;
        }
        this.cardloader = true;
        var config = {
          method: "post",
          url: api.api_url + "/digiLockerUpdate?mob=" + atob(localStorage.getItem("hash")) + "&father=" + this.fatherName + "&dob=" + this.dob + "&mother=" + this.mothername,
          headers: {"mobile":atob(localStorage.getItem("hash"))},
        };
        var axiosThis = this;
        axios(config)
          .then(function (res) {
            if (res.data.data == "User data has been inserted successfully") {
              axiosThis.toNext();
            } else {
              axiosThis.$emit("snack", 0, "Try again later");
            }
            axiosThis.cardloader = false;
          })
          .catch(function (error) {
            console.log(error);
            axiosThis.$emit("snack", 0, error);
            axiosThis.cardloader = false;
            alert("Server is not reachable, please try again later. \n  For support Contact us : 93 8010 8010  or  \n Mail us : assist@zebuetrade.com");
          });
      }
    },
    getPanocr(item) {
      let config = {
        method: "post",
        url: api.api_url + "/pan_ocr?mobile=" + atob(localStorage.getItem("hash")),
        headers: {"mobile":atob(localStorage.getItem("hash"))},
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((response) => {
          if (response.data && (response.data.msg == "data updated" || response.data.msg == "data already updated")) {
            // let vn = item.name.toUpperCase() == response.data.name.toUpperCase() ? 'yes' : 'no';
            let vd = new Date(response.data.pan_dob).toLocaleDateString() == new Date(item.DoB).toLocaleDateString() ? "yes" : "no";
            let valid = vd == "no" && new Date(response.data.pan_dob);
            if (valid) {
              axiosThis.ocrDOB["stat"] = true;
              axiosThis.ocrDOB["pan_dob"] = response.data.pan_dob;
              axiosThis.ocrDOB["aad_dob"] = item.DoB;
              axiosThis.dob = response.data.pan_dob;
              vd = "yes";
            } else {
              axiosThis.ocrDOB["stat"] = false;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setFathername(f) {
      let father = f.toUpperCase().trim();
      if (father.includes("F/O")) {
        father = father.replace("F/O", "");
      }
      if (father.includes("W/O")) {
        father = father.replace("W/O", "");
      }
      if (father.includes("D/O")) {
        father = father.replace("D/O", "");
      }
      if (father.includes("S/O")) {
        father = father.replace("S/O", "");
      }
      if (father.includes("C/O")) {
        father = father.replace("C/O", "");
      }
      if (father.includes("H/O")) {
        father = father.replace("H/O", "");
      }
      if (father[0] == ".") {
        father = father.slice(1);
      }
      father = father.replace(/[`~!@#$%^&*()_+={};:'",<>?|/]/g, "");
      return father;
    },
    setKradataUpdate() {
      const pan = (this.panInput || "").toString().trim();
      if (!pan) {
        this.$emit("snack", 0, "PAN not found. Please re-verify your PAN.");
        return;
      }
      this.cardloader = true;
      let data = JSON.stringify({kra_code: "no", pan: pan, mobile: atob(localStorage.getItem("hash"))});

      let config = {
        method: "post",
        url: api.api_url + "/pushKra",
        headers: {
          "Content-Type": "application/json",
          "mobile":atob(localStorage.getItem("hash"))
        },
        data: data,
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((res) => {
          if (res.data && res.data.status == "updated") {
            axiosThis.connectDigio();
          } else {
            axiosThis.$emit("snack", 0, res.data);
          }
          axiosThis.cardloader = false;
        })
        .catch((error) => {
          console.log(error);
          axiosThis.cardloader = false;
          axiosThis.$emit("snack", 0, error);
        });
    },
  },
  mounted() {
    this.kycLoader = true;
    var dataFromDigi = this.$route.query.code;
    var stateid = this.$route.query.state;
    var axiosThis = this;
    this.cardloader = false;
    if (dataFromDigi) {
      this.mobile_num = atob(localStorage.getItem("hash"));
      this.step = 3;
      var config = {
        method: "post",
        url: api.api_url + "/digiLockerFetch?mob=" + this.mobile_num + "&code=" + dataFromDigi + "&state=" + stateid,
        headers: {"mobile":atob(localStorage.getItem("hash"))},
      };
      axios(config)
        .then(function (response) {
          var sc403 = response.data && response.data.state_check;
          var is403_dlf = sc403 === 403 || sc403 === "403" || (sc403 && (sc403.status === 403 || sc403.code === 403 || sc403.statusCode === 403));
          if (is403_dlf) {
            var msg403_dlf = (sc403 && (sc403.message || sc403.msg)) || response.data.message || response.data.msg;
            if (msg403_dlf) axiosThis.$emit("snack", 0, msg403_dlf);
          }
          if (response.data["aadharNo"]) {
            localStorage.removeItem("digiattemt");
            // axiosThis.getPanocr(response.data);
            axiosThis.Otp_screen = true;
            axiosThis.KycFetchDisp = false;
            axiosThis.name = response.data["name"];
            axiosThis.dob = response.data["DoB"];
            axiosThis.aadharNo = response.data["aadharNo"];
            axiosThis.address = response.data["address"];
            axiosThis.country = response.data["country"];
            axiosThis.district = response.data["district"];
            axiosThis.panInput = response.data["pan"];
            if (response.data["fatherName"]) {
              var f = axiosThis.setFathername(response.data["fatherName"]);
              axiosThis.father = f ? true : false;
              axiosThis.fatherName = f;
            } else {
              axiosThis.father = false;
            }
            axiosThis.pinCode = response.data["pincode"];
            axiosThis.state = response.data["states"];
            axiosThis.gender = response.data["gender"];
          } else {
            alert("Unable to fetch your details, please try again.");
            if ("error" in response.data) {
              alert("Unable to fetch your details, please try again. \n For support Contact us : 93 8010 8010  or  \n Mail us : assist@zebuetrade.com");
            }
            axiosThis.$router.push("/digilockerconnect");
          }
          axiosThis.kycLoader = false;
        })
        .catch(function (error) {
          console.log(error);
          if (error && error.response && error.response.status === 403 && error.response.data && error.response.data.state_check) {
            axiosThis.$emit("snack", 0, error.response.data.state_check);
          }
          axiosThis.$emit("snack", 0, error);
          axiosThis.cardloader = false;
          alert("Server is not reachable, please try again later. \n For support Contact us : 93 8010 8010  or  \n Mail us : assist@zebuetrade.com");
          axiosThis.kycLoader = true;
          axiosThis.$router.push("/digilockerconnect");
        });
    } else {
      var configCheck = {
        method: "post",
        url: api.api_url + "/digiLockerFetch?mob=" + atob(localStorage.getItem("hash")),
        headers: {"mobile":atob(localStorage.getItem("hash"))},
      };
      axios(configCheck)
        .then(function (response) {
          var sc403 = response.data && response.data.state_check;
          var is403_dlf = sc403 === 403 || sc403 === "403" || (sc403 && (sc403.status === 403 || sc403.code === 403 || sc403.statusCode === 403));
          if (is403_dlf) {
            var msg403_dlf = (sc403 && (sc403.message || sc403.msg)) || response.data.message || response.data.msg;
            if (msg403_dlf) axiosThis.$emit("snack", 0, msg403_dlf);
          }
          if (response.data["name"] && response.data["aadharNo"]) {
            localStorage.removeItem("digiattemt");
            // axiosThis.getPanocr(response.data);
            axiosThis.KycFetchDisp = response.data.kra_code && response.data.kra_code == "yes" ? true : false;
            axiosThis.name = response.data["name"];
            axiosThis.dob = response.data["DoB"];
            axiosThis.aadharNo = response.data["aadharNo"];
            axiosThis.address = response.data["address"];
            axiosThis.country = response.data["country"];
            axiosThis.district = response.data["district"];
            axiosThis.panInput = response.data["pan"];
            if (response.data["fatherName"]) {
              var f = axiosThis.setFathername(response.data["fatherName"]);
              axiosThis.father =  false;
              axiosThis.fatherName = f;
            } else {
              axiosThis.father = false;
            }
            axiosThis.pinCode = response.data["pincode"];
            axiosThis.state = response.data["states"];
            axiosThis.gender = response.data["gender"];
            axiosThis.Otp_screen = true;
            axiosThis.kycLoader = false;
          } else {
            var att = localStorage.getItem("digiattemt");
            att = att >= 1 ? Number(att) + 1 : 1;
            localStorage.setItem("digiattemt", att);
            if (att > 2) {
              alert("Something went wrong, please try again. \n  For support Contact us : 93 8010 8010  or  \n Mail us : assist@zebuetrade.com");
            }
            axiosThis.$router.push("/digilockerconnect");
          }
        })
        .catch(function (error) {
          console.log(error);
          if (error && error.response && error.response.status === 403 && error.response.data && error.response.data.state_check) {
            axiosThis.$emit("snack", 0, error.response.data.state_check);
          }
          axiosThis.$emit("snack", 0, error);
          axiosThis.cardloader = false;
          var att = localStorage.getItem("digiattemt");
          att = att >= 1 ? att + 1 : 1;
          localStorage.setItem("digiattemt", att);
          if (att > 2) {
            alert("Server is not reachable, please try again later. \n  For support Contact us : 93 8010 8010  or  \n Mail us : assist@zebuetrade.com");
          }
          axiosThis.$router.push("/digilockerconnect");
        });
    }
  },
};
</script>
